// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"89d67d8f","150":"480899a3","210":"3d07d8d1","263":"bf59b666","488":"bab1e1b1","814":"d3263a73","871":"c7d41753","887":"7181363d"}[chunkId] + ".chunk.js";
};